












import Vue from 'vue';
import BaseText from './BaseText.vue';

export default Vue.extend({
  components: {
    BaseText
  },
  props: {
    title: {
      type: String,
      required: true
    }
  }

})
